import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type SredPayrollExpenseLayoutAnalyticIds = {
  bulkEditInExcelBtnId?: string;
  connectProviderBtnId?: string;
};

export const useSredPayrollExpenseLayoutAnalyticIds = (): SredPayrollExpenseLayoutAnalyticIds => ({
  bulkEditInExcelBtnId: useAnalyticId(AnalyticIdentifier.SRED_PAYROLL_EXPENSE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN),
  connectProviderBtnId: useAnalyticId(AnalyticIdentifier.SRED_PAYROLL_EXPENSE_LAYOUT_CONNECT_PROVIDER_BTN),
});
